export default __webpack_public_path__ + "static/media/UntitledSans-Bold.f9b145b6.woff";